import React from 'react';
import { useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const navigate = useNavigate();
  return (
    <nav aria-label="Breadcrumb" className="mb-5">
      <ul className="uk-breadcrumb flex gap-2">
        {items.map((item, index) => (
          <li
            key={index}
            className={`text-xl font-semibold ${
              item.href ? 'text-light-40' : 'uk-disabled text-black'
            }`}
          >
            {item.href ? (
              <button className="text-sm" onClick={() => navigate(-1)}>
                {item.label}
              </button>
            ) : (
              <span>{item.label}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
